import { useCallback, useEffect, useMemo, useState } from 'react';
import usePollPendingSecurityChecks from 'hooks/usePollPendingSecurityChecks';
import { listDocumentsIcs2 } from 'store/file-upload/client';
import { Ics2DocumentsByReferral, indexSelectableByReferral } from '../referralDocuments';

const useIcs2ReferralDocuments = (declarationId?: string) => {
    const [documents, setDocuments] = useState<Ics2DocumentsByReferral>({});
    const [fetchedAt, setFetchedAt] = useState<number | null>(null);

    const refresh = useCallback(async (): Promise<Ics2DocumentsByReferral | undefined> => {
        if (!declarationId) return {};
        try {
            const index = indexSelectableByReferral(await listDocumentsIcs2(declarationId));
            setDocuments(index);
            setFetchedAt(Date.now());
            return index;
        } catch {
            return undefined;
        }
    }, [declarationId]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const allDocuments = useMemo(() => Object.values(documents).flat(), [documents]);

    // Nothing reports a finished scan, so a card's Send Response only unblocks if we go back and look.
    usePollPendingSecurityChecks(allDocuments, refresh, fetchedAt, { enabled: Boolean(declarationId) });

    const readLatest = useCallback(async () => (await refresh()) ?? documents, [refresh, documents]);

    return { documents, refresh, readLatest };
};

export default useIcs2ReferralDocuments;
